import { GlobalSettingsComponent } from "./global-settings.component";
import { MailConfigSettingComponent } from "./mail-config-setting/mail-config-setting.component";
import { BookingDayCountConfigComponent } from "./booking-day-count-config/booking-day-count-config.component"
import { OpenBookingStatusComponent } from "./booking-count-component/booking-count-component.component";


export const GlobalSettingsDeclaration = [
    GlobalSettingsComponent,
    MailConfigSettingComponent,
    BookingDayCountConfigComponent,
    OpenBookingStatusComponent
]